export class Tower {
    public damage_per_shot: number = 1.5;
    public shots_per_seconds: number = 2;
    public range: number = 4;
    public range_squared: number = this.range * this.range;
    public projectile_speed: number = 7;
    public cooldown: number = 0;
}